export default __webpack_public_path__ + "static/media/codefidata03.b0a381cf.png";